import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios";
import { Redirect } from "react-router-dom";
import ProductGroupTableRow from "../../../components/Settings/ProductGroupTableRow/ProductGroupTableRow";
import Button from "@material-ui/core/Button";
// Dialog Dependencies
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { toast } from "react-toastify";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import translator from "../../../utils/translator";

export class ProductGroups extends Component {
	state = {
		listOfProductGroups: [],
		queryTheDatabase: "",
		newProductGroupName: "",
		dialog: null
	};

	toast_config = {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
    };

	addNewProductGroup = async () => {
		if(this.state.newProductGroupName === "" || this.state.newProductGroupName === undefined || this.state.newProductGroupName === null) {
			return toast.error(translator("Misc", "product_group_name_error"), this.toast_config);
		}
		let addNewProductGroupAPIUrl = this.props.APIUrl + "/settings/product-groups/add";
		let data = {
			trendId: localStorage.getItem("trendId"),
			userInput: this.state.newProductGroupName
		};
		let addNewProductGroupAPIResponse = await Axios.post(addNewProductGroupAPIUrl, data);

		let redirect = <Redirect to={ '/settings/product-groups/edit?productGroupId=' + addNewProductGroupAPIResponse.data.id + '&groupName=' + addNewProductGroupAPIResponse.data.title } />;
		this.componentDidMount();

		this.setState({ dialog: (
			<Dialog open={true} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title set-price-dialog-header">
					Success{" "}
				</DialogTitle>
				<DialogContent>You have successfully created a new product group. You will now be redirected back to the new product group.</DialogContent>
				<DialogActions>
					<Button
						onClick={() => this.setState({ redirect: redirect })}
						color="primary"
					>
						Okay
					</Button>
				</DialogActions>
			</Dialog>
		)});
	};

	searchProductGroups = async () => {
		let getProductGroupsAPIUrl = this.props.APIUrl + "/settings/product-groups";
		let data = {
			query: this.state.queryTheDatabase,
			trendId: localStorage.getItem('trendId')
		};
		let getProductGroupsAPIResponse = await Axios.post(getProductGroupsAPIUrl, data);

		let productGroups;
		if (getProductGroupsAPIResponse.data.listOfProductGroups) {
			productGroups = getProductGroupsAPIResponse.data.listOfProductGroups;
			let storeListOfProductGroups = await productGroups.map((productGroup, index) => (
				<ProductGroupTableRow
					index={index}
					groupName={productGroup.title}
					productGroupId={productGroup.id}
				/>
			));
			this.setState({ listOfProductGroups: storeListOfProductGroups });
		}
	};

	async componentDidMount() {
		let getProductGroupsAPIUrl = this.props.APIUrl + "/settings/product-groups";
		let data = {
			trendId: localStorage.getItem('trendId')
		}
		let getProductGroupsAPIResponse = await Axios.post(getProductGroupsAPIUrl, data);

		let productGroups;
		if (getProductGroupsAPIResponse.data.listOfProductGroups) {
			productGroups = getProductGroupsAPIResponse.data.listOfProductGroups;

			let storeListOfProductGroups = await productGroups.map((productGroup, index) => (
				<ProductGroupTableRow
					index={index}
					groupName={productGroup.title}
					productGroupId={productGroup.id}
				/>
			));
			this.setState({ listOfProductGroups: storeListOfProductGroups });
		}
	}

	runOnEnter(event, func) {
		if (event.keyCode == 13 || event.which === 13) {
			event.preventDefault();
			func();
		}
	}

	render() {
		let productGroups = this.state.listOfProductGroups;
		let redirect = this.state.redirect;
		let main = (
			<>
				{redirect}
				{this.state.dialog}
				<div class="card user-profile-card">
					<div class="card-body">
						<form class="form-inline">
							<input
								class="form-control form-control-sm ml-3 w-75 "
								type="text"
								placeholder={translator("Admin Product Groups", "search_label")}
								aria-label="Search"
								onChange={event =>
									this.setState({ queryTheDatabase: event.target.value })
								}
								onKeyPress={(event) => this.runOnEnter(event, this.searchProductGroups)}
							/>
							<button
								onClick={this.searchProductGroups}
								type="button"
								class="btn btn-outline-primary"
							>
								<i class="fa fa-search" />
							</button>
						</form>
					</div>
				</div>
				<div class="card user-profile-card">
					<div class="card-body">
						<form class="form-inline">
							<label>{translator("Admin Product Groups", "new_product_group")}</label>
							<input
								class="form-control form-control-sm ml-3  "
								type="text"
								placeholder={translator("Admin Product Groups", "product_group_name_placeholder")}
								aria-label="Search"
								style={{ width: "50%" }}
								onChange={event =>
									this.setState({ newProductGroupName: event.target.value })
								}
								onKeyPress={(event) => this.runOnEnter(event, this.addNewProductGroup)}
							/>
							<button
								onClick={this.addNewProductGroup}
								type="button"
								class="btn btn-outline-primary"
								style={{ whiteSpace: "nowrap", paddingRight: "6em" }}
							>
								{translator("Admin Product Groups", "add_group_btn")}
							</button>
						</form>
					</div>
				</div>
				<div class="card user-profile-card">
					<div class="card-body" />
					<table class="table search-results-table">
						<thead id="search-projects-table-header">
							<tr>
								<th scope="col" />
								<th scope="col">{translator("Admin Product Groups", "group_name_header")}</th>
								<th scope="col" />
							</tr>
						</thead>
						<tbody>{productGroups.map(productGroup => productGroup)}</tbody>
					</table>
				</div>
			</>
		);

		return <SettingsWrapper header={translator("Admin Product Groups", "page_title")} main={main} />;
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ProductGroups);
